<template>
    <div class="jd-expert-item">
        <div class="jd-expert-item--bd" v-if="info">
            <k-view-two
                :img="info.logo|resize(100,100)"
                :title="info.name"
                :tags="info.teacherTabs"
            />
            <div class="jd-expert-item--status">
                <slot name="status"></slot>
            </div>
        </div>
        <k-row class="jd-expert-item--desc fts-sm"  v-if="info && info.des">
            <k-col span="18" class="text-ellipsis">{{info.des || ''}}  </k-col>
            <k-col v-if="info.aid" span="6" class="ta-right cl-blue">
                <router-link :to="`/detail?aid=${info.aid}`" class="cl-blue">了解更多>></router-link>
            </k-col>
        </k-row>
        <div class="k-hairline--top"></div>
        <appraiser-good v-if="good && info" :wcount="info.wcount || ''" :through="info.through || ''" :slow="(info.slow || 0)|fen2yuan" :fast="(info.fast || 0)|fen2yuan" />
        <slot name="select">

        </slot>
        <k-hr v-if="hr" />
    </div>
</template>

<script>
    export default {
        name: "appraiser-item",
        props : ["good","info","hr",'appraiser'],
        computed : {

        },
        components : {

        }
    }
</script>

<style scoped>

</style>